import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { MaterialModule } from '../material/material.module';
import { ReusableMerchantTemplateModule } from '../../pages/merchants/merchant-template/reusable-merchant-template.module';
import { StatementTemplateComponent } from './statement-template.component';

@NgModule({
    declarations: [StatementTemplateComponent],
    imports: [
        CommonModule,
        ReactiveFormsModule,
        FlexLayoutModule,
        MaterialModule,
        ReusableMerchantTemplateModule,
    ],
    exports: [StatementTemplateComponent]
})
export class StatementTemplateModule {}